module.exports = __webpack_public_path__ + "img/24-7-access-to-our-platform.6ca26740.svg";